import React from "react";
import Select from "react-select";
import TransitionChevron from "./../Widgets/TransitionChevron"
import styles from "./InlineSelectorStyles.module.scss"
import InlineLoader from "../Loaders/InlineLoader";
import classNames from "classnames";
import _ from "lodash";

const contentTypeSelectorStyles = {
    option: (provided, state) => ({
        ...provided,
        backgroundColor: (!state.isDisabled && state.isFocused) ? "var(--hover-background) !important" : "transparent !important",
        color: state.isDisabled ? "var(--text-disabled)" : (state.isSelected ? "var(--text-button-primary)" : "var(--text-primary)"),
        padding: "12px 24px",
        cursor: state.isDisabled ? "not-allowed" : "pointer",
        whiteSpace: "nowrap"
    }),
    container: (provided) => ({
        ...provided,
        display: "inline-flex",
        borderBottom: "1px solid var(--field-border)"
    }),
    singleValue: () => ({
        color: "var(--text-primary)",
        fontSize: 14,
        display: "inline"
    }),
    control: () => ({
        width: "initial",
        display: "inline-grid",
        cursor: "pointer",
        alignItems: "center",
        gridTemplateColumns: "1fr 13px"
    }),
    valueContainer: () => ({
        display: "inline",
        paddingRight: 8,
        textOverflow: "ellipsis",
        overflow: "hidden",
        whiteSpace: "nowrap"
    }),
    indicatorsContainer: () => ({
        display: "inline",
        position: "relative"
    }),
    indicatorSeparator: () => ({
        display: "none"
    }),
    input: (provided) => ({
        ...provided,
        display: "inline"
    }),
    menuList: (provided) => ({
        ...provided,
        backgroundColor: "var(--content-background)",
        boxShadow: "2px 2px 6px 0 var(--drop-shadow)",
        border: "none"
    }),
    menuPortal: base => ({ ...base, zIndex: 99999999999999999}),
    menu: (provided) => ({
        ...provided,
        border: "none",
        minWidth: 240,
        transform: "translateX(-50%)",
        left: "50%",
        width: "auto"
    })
};

const DropdownIndicator = ({ selectProps: { menuIsOpen } }) => {
    return <TransitionChevron isActive={menuIsOpen} className={styles['chevron']} color="text"/>
};

export default React.memo(({ label, onChange, value, options, name, isLoading, className, style, customSelectorStyles = {}, ...rest }) => {
    return <div className={classNames(styles.base, className)} style={style}>
        <label>
            {label && <span>{label}</span>}
            {isLoading && <InlineLoader style={{ alignSelf: "center" }}/>}
            {!isLoading && <Select components={{ DropdownIndicator }} name={name}
                                   styles={{ ...contentTypeSelectorStyles, ...customSelectorStyles }}
                                   isSearchable={false}
                                   options={options}
                                   onChange={onChange}
                                   value={value}
                                   isOptionDisabled={option => !!option.isDisabled || _.isUndefined(option.value)}
                                   {...rest}/>}
        </label>
    </div>
})
